import { List } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Preloader from '../../../components/common/Preloader';
import { savedSlipViewEnter } from '../actions';
import { getSavedSlipsIds, isSavedSlipsViewLoading } from '../selectors';
import SavedSlipConnect from './SavedSlip';
import { BETTING_BUDDY } from '../../../routes/paths';
import { hasSavedSlips } from '../../../modules/account/selectors';

export class SavedSlips extends React.Component {
  componentDidMount() {
    this.props.viewEnter();
  }

  componentWillReceiveProps(nextProps) {
    const nextShowSavedSlips = nextProps.showSavedSlips;
    const { history } = this.props;

    if (!nextShowSavedSlips) {
      history.push(BETTING_BUDDY);
    }
    return true;
  }

  render() {
    const { ids, loading } = this.props;

    if (loading || !ids.size) {
      return (
        <div className="saved-slips__preloader">
          <Preloader />
        </div>
      );
    }

    return (
      <div className="saved-slips">
        {ids.map(id => (
          <SavedSlipConnect id={id} key={id} />
        ))}
      </div>
    );
  }
}

SavedSlips.propTypes = {
  viewEnter: PropTypes.func.isRequired,
  ids: PropTypes.instanceOf(List).isRequired,
  loading: PropTypes.bool,
  showSavedSlips: PropTypes.bool,
  history: PropTypes.object.isRequired
};

SavedSlips.defaultProps = {
  loading: false,
  showSavedSlips: true
};

const mapStateToProps = state => ({
  ids: getSavedSlipsIds(state),
  showSavedSlips: hasSavedSlips(state),
  loading: isSavedSlipsViewLoading(state)
});

const mapDispatchToProps = {
  viewEnter: savedSlipViewEnter
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SavedSlips));
